import { CalendarEvent } from '../types/calendar';

/**
 * Backend expands recurring events into instances with IDs like `${baseId}_${occurrenceIndex}`.
 * Since the backend only supports updating/deleting the base event, we need helpers to
 * map instance IDs back to base IDs.
 */
export function getBaseEventId(eventId: string): string {
  // Only treat the suffix after the last underscore as an instance index.
  // If an ID legitimately contains underscores, this still behaves consistently
  // with backend instance generation (`${event.id}_${occurrenceCount}`).
  if (!eventId.includes('_')) return eventId;
  return eventId.substring(0, eventId.lastIndexOf('_'));
}

export function isExpandedRecurringInstance(event: Pick<CalendarEvent, 'id' | 'isRecurring'>): boolean {
  return !!event.isRecurring && event.id.includes('_');
}

